import React, {useState} from 'react';
import './style.css';
import { Alert, Button, Form, Input, Spin } from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { applicationConfig } from '../../../Util/config';
import ReCAPTCHA from 'react-google-recaptcha';
import {getUserAndUpdateTerms,  signIn } from '../../../Store/Actions';
import { useThrottle } from '../../../hooks/useThrottle';
import {
  validateEmailInput,
} from './../../../Util/commonUtility';
import useLocalization from '../../../Localization';
import {Modal} from 'antd';
import { useJWTAuthActions } from '../../../Api/JWTAuthProvider';

const LoginForm = ({pbssInternationalData}) => {
  const [showTerms, setShowTerms] = useState(false);
  const[isAcceptLoading, setIsAcceptLoading] = useState(false);
    const {logout} = useJWTAuthActions();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ApplicationString } = useLocalization();
  const [loginForm] = Form.useForm();
  const onLogIn = (values) => {
    dispatch(signIn(values, navigate, setShowTerms));
  };
  const debouncedOnLogIn = useThrottle(onLogIn, 3000);

  const onFinish = (values) => {
    debouncedOnLogIn(values);
  };

  const handleAccept = () => {
    setIsAcceptLoading(true);
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const id = userInfo?.id;
    dispatch(getUserAndUpdateTerms(id, navigate , setShowTerms , setIsAcceptLoading));
  };

  const handleModalClose = () => {
    setShowTerms(false);
    loginForm.resetFields();
    logout();
  };

  return (
    <React.Fragment>
      <div className='login-form'>
        <Modal
          open={showTerms}
          onCancel={handleModalClose}
          footer={[
            <Button
              key='view'
              type='link'
              href={`${applicationConfig.UPLOAD_URL}/${pbssInternationalData?.terms_and_conditions_id?.name}`}    target='_blank'>
              {
                ApplicationString[ 
                  'userLoginComponent.popup.button.viewTerms&Conditions'
                ]
              }
            </Button>,
            <Button key='accept' type='primary' onClick={handleAccept}>
              {isAcceptLoading ? (
                <>
                  <Spin indicator={<LoadingOutlined spin style={{color: '#fff'}} />} /> {ApplicationString['userLoginComponent.popup.button.accepting']}
                </>
              ) : (
                ApplicationString['userLoginComponent.popup.button.accept']
              )}
            </Button>,
          ]}
          centered
          title={ApplicationString['userLoginComponent.popup.heading']}>
          <p>{ApplicationString['userLoginComponent.popup.subheading']}</p>
        </Modal>
        <Form
          name='login'
          onFinish={onFinish}
          initialValues={''}
          form={loginForm}>
          <div className='antd-login-form-fields-container'>
            <Form.Item
              name='email'
              rules={[
                {
                  required: true,
                  message: ApplicationString['userRegisterComponent.emailValidation'],
                },
                {
                  validator: (_, value) => validateEmailInput(value, 'Email', ApplicationString['userRegisterComponent.emailValidation']),
                },
              ]}>
              <Input
                prefixCls='common-input-user-login'
                placeholder={ApplicationString['userLoginComponent.email']}
              />
            </Form.Item>
            <Alert
              type="info"
              showIcon
              message={ApplicationString['userLoginComponent.addNote']}
              className="login-email-note"
            />
            <Form.Item
              name='password'
              rules={[
                {
                  required: true,
                  message:
                    ApplicationString['userLoginComponent.password.validation'],
                },
              ]}
              hasFeedback>
              <Input.Password
                prefixCls='common-input-user-login'
                placeholder={ApplicationString['userLoginComponent.password']}
              />
            </Form.Item>
          </div>

          <div
            className='password-options-login'
            id='login-forgotPassword-link'>
            <div>
              <div className='signup-link-login'>
                {ApplicationString['userLoginComponent.notAMember']}
              </div>
              <div className='signup-link-description'>
                <Link id='login-freeAccount-link' to={'../register'}>
                  {ApplicationString['userLoginComponent.createAccount']}
                </Link>
              </div>
            </div>
            <Link to={'../resetPassword'}>
              {ApplicationString['userLoginComponent.forgotPassword']}
            </Link>
          </div>
          <Form.Item prefixCls='re-captcha-login'>
            <p className='re-captcha-label-login'>
              {ApplicationString['userRegisterComponent.captcha.title']}
            </p>
            <Form.Item
              name='captcha'
              noStyle
              rules={[
                {
                  required: true,
                  message:
                    ApplicationString['userRegisterComponent.captcha'],
                },
              ]}>
              <ReCAPTCHA
                sitekey={applicationConfig.CAPTCHA_SITE_KEY}></ReCAPTCHA>
            </Form.Item>
          </Form.Item>
          <Form.Item>
            <Button
              id='login-submit-button'
              type='primary'
              htmlType='submit'
              prefixCls='submit-login-page'
              className='login-button'>
              {ApplicationString['userLoginComponent.login']}
            </Button>
          </Form.Item>
        </Form>
        <div className='captcha'>{/* Add your captcha component here */}</div>
      </div>
    </React.Fragment>
  );
};

export default LoginForm;
